export default {
    'grapesjs-fonts': {
        'Fonts': 'Polices',
        'You must provide Google font api key': 'Vous devez fournir une clé API Google font, voir https://developers.google.com/fonts/docs/developer_api#APIKey',
        'Family': 'Famille',
        'Search': 'Rechercher une police',
        'Add font': 'Installer la police',
        'Remove': 'Supprimer',
        'Save': 'Enregistrer',
        'Cancel': 'Annuler',
        'Installed fonts': 'Polices installées',
    },
}


